// extracted by mini-css-extract-plugin
export var equalColumn = "_f3-0";